import { HexMath } from "../../HexMath";
import {TOKENS} from "../../../constants/tokens";

/**
 * Рассчитывает ячейки, на которых запрещено строительство обычных строений (ферма, казарма, шахта и т.д.)
 * Запрещенными являются все ячейки смежные с кварталами противников, которые входят в список доступных для строительства
 * 
 * @param {Object} citiesCache - кэш городов
 * @param {string} currentPlayerColor - цвет текущего игрока
 * @param {Array<string>} availableConstructionCells - массив доступных для строительства ячеек
 * @returns {Set<string>} набор ключей заблокированных ячеек для обычных строений
 */
export const calculateBlockedConstructionCellsForBuildingsReliedOnQuarter = (citiesCache, currentPlayerColor, availableConstructionCells) => {
  const hexMath = new HexMath(30, 'flat');
  const enemyQuarterAdjacentCells = new Set();
  
  // Собираем все ячейки смежные с кварталами всех игроков кроме текущего
  Object.entries(citiesCache).forEach(([playerColor, playerCities]) => {
    // Пропускаем города текущего игрока
    if (playerColor === currentPlayerColor) {
      return;
    }
    
    playerCities.forEach(city => {
      // Добавляем ячейки смежные с центральным кварталом
      if (city.centralQuarter) {
        const [q, r] = city.centralQuarter.split(',').map(Number);
        const neighbors = hexMath.getNeighborsFlatTop(q, r);
        neighbors.forEach(([nq, nr]) => {
          enemyQuarterAdjacentCells.add(`${nq},${nr}`);
        });
      }
      
      // Добавляем ячейки смежные с обычными кварталами
      if (city[TOKENS.QUARTER] && Array.isArray(city[TOKENS.QUARTER])) {
        city[TOKENS.QUARTER].forEach(quarterKey => {
          const [q, r] = quarterKey.split(',').map(Number);
          const neighbors = hexMath.getNeighborsFlatTop(q, r);
          neighbors.forEach(([nq, nr]) => {
            enemyQuarterAdjacentCells.add(`${nq},${nr}`);
          });
        });
      }
    });
  });
  
  // Создаем множество только из тех ячеек которые одновременно являются доступными для строительства и смежными с вражескими кварталами
  const availableSet = new Set(availableConstructionCells);
  const blockedCells = new Set();
  
  enemyQuarterAdjacentCells.forEach(cellKey => {
    if (availableSet.has(cellKey)) {
      blockedCells.add(cellKey);
    }
  });
  
  return blockedCells;
};
